import { Badge } from '@/components/ui/badge';
import { daysUntilDate } from '@/lib/date';
import { SALE_STATUSES, STATUS_LABELS } from '@/lib/sale-status';

export { SALE_STATUSES, STATUS_LABELS };

export const STATUS_VARIANTS: Record<
  string,
  'default' | 'success' | 'destructive' | 'secondary' | 'warning'
> = {
  budget: 'secondary',
  pending: 'warning',
  confirmed: 'default',
  in_production: 'default',
  ready: 'default',
  shipped: 'default',
  delivered: 'success',
  canceled: 'destructive',
};

/** Cor (token CSS) usada no dot/borda de cada coluna do kanban. */
export const STATUS_DOT_COLOR: Record<string, string> = {
  budget: 'var(--faint)',
  pending: 'var(--warning)',
  confirmed: 'var(--primary)',
  in_production: 'var(--primary)',
  ready: 'var(--success)',
  shipped: 'var(--primary)',
  delivered: 'var(--success)',
  canceled: 'var(--destructive)',
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={STATUS_VARIANTS[status] ?? 'default'}>
      {STATUS_LABELS[status] ?? status}
    </Badge>
  );
}

export function DeliveryBadge({
  deliveryDate,
  status,
}: {
  deliveryDate: string;
  status: string;
}) {
  if (status === 'delivered' || status === 'canceled') {
    return <span className="text-muted-foreground text-sm">—</span>;
  }

  const days = daysUntilDate(deliveryDate);

  if (days < 0) return <Badge variant="destructive">Atrasado ({Math.abs(days)}d)</Badge>;
  if (days === 0) return <Badge variant="destructive">Entrega hoje</Badge>;
  if (days <= 3) return <Badge variant="secondary">Faltam {days}d</Badge>;
  return <Badge variant="success">Faltam {days}d</Badge>;
}
